/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Box } from 'rebass'

import { NavBar } from '../elements'

export default ({ children, props }) =>
    (
        <Box
            {...props}
            sx={{
                width: '100%',
                diplay: 'flex',
                alignItems: 'center',
                variant: 'layout.header',
            }}
        >
            <NavBar />
        </Box>
    );